export default {
  getIsFoldMenu: state => state.isFoldMenu,
  getHelpObjList: state => state.helpObjList,
  getHelpObj: state => state.helpObj,
  getEditorContentStyle: state => state.editorContentStyle,
};



// WEBPACK FOOTER //
// ./src/vuex/common/common/commonGetters.js